import {
	PUBLIC_SUPABASE_ANON_KEY,
	PUBLIC_SUPABASE_URL,
} from '$env/static/public';
import { setSupabaseClient } from '$lib/stores/supabaseClient';
import type { LayoutLoad } from './$types';
import {
	createBrowserClient,
	createServerClient,
	isBrowser,
	parse,
} from '@supabase/ssr';

export const load: LayoutLoad = async ({ fetch, data, depends }) => {
	depends('supabase:auth');

	let supabase;

	if (isBrowser()) {
		supabase = createBrowserClient(
			PUBLIC_SUPABASE_URL,
			PUBLIC_SUPABASE_ANON_KEY,
			{
				global: {
					fetch,
				},
				cookies: {
					get(key) {
						const cookie = parse(document.cookie);
						return cookie[key];
					},
				},
			},
		);
		setSupabaseClient(supabase);
	} else {
		supabase = createServerClient(
			PUBLIC_SUPABASE_URL,
			PUBLIC_SUPABASE_ANON_KEY,
			{
				global: {
					fetch,
				},
				cookies: {
					get() {
						return JSON.stringify(data.session);
					},
				},
			},
		);
	}

	const {
		data: { session },
	} = await supabase.auth.getSession();

	const {
		data: { user },
	} = await supabase.auth.getUser();

	return {
		supabase,
		session,
		user,
	};
};
